import { createFileRoute } from "@tanstack/react-router";
import { TravelCostsSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/resources/travel-costs")({
  component: TravelCostsSettingsPage,
});
